export default {
  buyer_exp: {
    buyer_exp: true,
  },
}
